export function inventoryLandingTop(resultsTop: number, scrollY: number, headerHeight: number) {
  return Math.max(0, resultsTop + scrollY - headerHeight);
}

// Track only URL writes made by live typing, not incoming links or filters.
export function createInventoryLandingIntent() {
  const previews = new Set<string>();
  const key = (search: Record<string, unknown>) => JSON.stringify(
    Object.entries(search).sort(([a], [b]) => a.localeCompare(b)).map(([name, value]) => [name, String(value)]),
  );
  return {
    markPreview(search: Record<string, unknown>) { previews.add(key(search)); },
    shouldLand(fromPath: string | undefined, toPath: string, search: Record<string, unknown>) {
      const preview = previews.delete(key(search));
      if (toPath.replace(/\/$/, '') !== '/rv-search') return false;
      return fromPath?.replace(/\/$/, '') !== '/rv-search' || !preview;
    },
  };
}